import { render, staticRenderFns } from "./localscann.vue?vue&type=template&id=f8d2dff6&scoped=true&"
import script from "./localscann.vue?vue&type=script&lang=js&"
export * from "./localscann.vue?vue&type=script&lang=js&"
import style0 from "./localscann.vue?vue&type=style&index=0&id=f8d2dff6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8d2dff6",
  null
  
)

export default component.exports